declare function require(moduleName: string): any;

const {version: appVersion} = require('./../../package.json');

export const environment = {
    production: true,
    version: appVersion,
    nomeApp: "Admin",
    api_escopo: 'sia:usuario ' +
        'GMTAUT01 GMTAUT02 GMTAUT03 GMTAUT04 GMTAUT05 GMTAUT06 GMTAUT07 ' +
        'GMTPTL00 GMTPTL01 GMTPTL02 GMTPTL03 ' +
        'GMTMON01 GMTMON02 GMTMON03 GMTMON04 ' +
        'GMTCAT02 GMTCAT03 GMTCAT04 GMTCAT05 GMTCAT06 GMTCAT07 GMTCAT08 GMTCAT09 GMTCAT10 GMTCAT17 GMTCAT18 GMTCAT19 ' +
        'GMTSIA01 GMTSIA02 GMTSIA03 ' +
        'catalogo:engine',

    configLocalDes: {
        'ambiente': 'LocalDes',

        'api_autorizador': 'https://gmtedi.desenv.bb.com.br/gmt-autorizador-api',
        // 'api_catalogo': 'https://gmtedi.desenv.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtedi.desenv.bb.com.br/gmt-sia-api',
        'api_painel': "https://gmtedi.desenv.bb.com.br/gmt-painel-api",

        'url_monitoramento': 'https://gmtedi.desenv.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtedi.desenv.bb.com.br/#/home',
        'url_cadastro': 'https://gmtedi.desenv.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtedi.desenv.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtedi.desenv.bb.com.br/portal/#/home',


        // "api_sia": "http://localhost:7001/gmt-sia-api",
        // "api_protocolo": "http://localhost:7001/gmt-protocolo-api",
        // "api_autorizador": "http://localhost:7001/gmt-autorizador-api",
        // "api_monitorador": "http://localhost:7001/gmt-monitorador-api",
        "api_catalogo": "http://localhost:7001/gmt-catalogo-api",

        'timeout_apis': 10000,
        'timeout': 900

    },

    configLocalHm: {
        'ambiente': 'LocalHm',

        'api_autorizador': 'https://gmtedi.hm.bb.com.br/gmt-autorizador-api',
        'api_catalogo': 'https://gmtedi.hm.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtedi.hm.bb.com.br/gmt-sia-api',
        'api_painel': "https://gmtedi.hm.bb.com.br/gmt-painel-api",


        'url_monitoramento': 'https://gmtedi.hm.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtedi.hm.bb.com.br/#/home',
        'url_cadastro': 'https://gmtedi.hm.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtedi.hm.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtedi.hm.bb.com.br/portal/#/home',

        // "api_autorizador": "http://localhost:7001/gmt-autorizador-api",
        // "api_catalogo": "http://localhost:7001/gmt-catalogo-api",
        // "api_sia": "http://localhost:7001/gmt-sia-api",

        'timeout_apis': 10000,
        'timeout': 900

    },

    configLocalPrd: {
        'ambiente': 'LocalPrd',

        'api_autorizador': 'https://gmtedi.bb.com.br/gmt-autorizador-api',
        'api_catalogo': 'https://gmtedi.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtedi.bb.com.br/gmt-sia-api',
        'api_painel': "https://gmtedi.bb.com.br/gmt-painel-api",


        // "api_autorizador": "http://localhost:7001/gmt-autorizador-api",
        // "api_catalogo": "http://localhost:7001/gmt-catalogo-api",
        // "api_sia": "http://localhost:7001/gmt-sia-api",

        'url_monitoramento': 'https://gmtedi.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtedi.bb.com.br/#/home',
        'url_cadastro': 'https://gmtedi.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtedi.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtedi.bb.com.br/portal/#/home',

        'timeout_apis': 10000,
        'timeout': 900

    },

    configLocalProdTor: {
        'ambiente': 'GMTOR',
        'api_autorizador': 'https://gmtor.bb.com.br/gmt-autorizador-api',
        // 'api_catalogo': 'https://gmtor.bb.com.br/gmt-catalogo-api',
        "api_catalogo": "http://localhost:7001/gmt-catalogo-api",
        'api_painel': "https://gmtor.bb.com.br/gmt-painel-api",


        'api_sia': 'https://gmtor.bb.com.br/gmt-sia-api',

        'url_monitoramento': 'https://gmtor.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtor.bb.com.br/#/home',
        'url_cadastro': 'https://gmtor.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtor.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtor.bb.com.br/portal/#/home',

        'timeout_apis': 10000,
        'timeout': 900
    },

    configDesenv: {
        'ambiente': 'Desenvolvimento',
        'api_autorizador': 'https://gmtedi.desenv.bb.com.br/gmt-autorizador-api',
        'api_catalogo': 'https://gmtedi.desenv.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtedi.desenv.bb.com.br/gmt-sia-api',
        'api_painel': "https://gmtedi.desenv.bb.com.br/gmt-painel-api",

        'url_monitoramento': 'https://gmtedi.desenv.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtedi.desenv.bb.com.br/#/home',
        'url_cadastro': 'https://gmtedi.desenv.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtedi.desenv.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtedi.desenv.bb.com.br/portal/#/home',

        'timeout_apis': 10000,
        'timeout': 900
    },

    configHm: {
        'ambiente': 'Homologação',
        'api_autorizador': 'https://gmtedi.hm.bb.com.br/gmt-autorizador-api',
        'api_catalogo': 'https://gmtedi.hm.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtedi.hm.bb.com.br/gmt-sia-api',
        'api_painel': "https://gmtedi.hm.bb.com.br/gmt-painel-api",

        'url_monitoramento': 'https://gmtedi.hm.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtedi.hm.bb.com.br/#/home',
        'url_cadastro': 'https://gmtedi.hm.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtedi.hm.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtedi.hm.bb.com.br/portal/#/home',

        'timeout_apis': 10000,
        'timeout': 900
    },

    configProd: {
        'ambiente': 'Produção',
        'api_autorizador': 'https://gmtedi.bb.com.br/gmt-autorizador-api',
        'api_catalogo': 'https://gmtedi.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtedi.bb.com.br/gmt-sia-api',
        'api_painel': "https://gmtedi.bb.com.br/gmt-painel-api",

        'url_monitoramento': 'https://gmtedi.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtedi.bb.com.br/#/home',
        'url_cadastro': 'https://gmtedi.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtedi.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtedi.bb.com.br/portal/#/home',

        'timeout_apis': 10000,
        'timeout': 900
    },

    configProdTor: {
        'ambiente': 'GMTOR',
        'api_autorizador': 'https://gmtor.bb.com.br/gmt-autorizador-api',
        'api_catalogo': 'https://gmtor.bb.com.br/gmt-catalogo-api',
        'api_sia': 'https://gmtor.bb.com.br/gmt-sia-api',

        'url_monitoramento': 'https://gmtor.bb.com.br/monitorador/#/home',
        'url_siaweb': 'https://gmtor.bb.com.br/#/home',
        'url_cadastro': 'https://gmtor.bb.com.br/cadastro/#/home',
        'url_administracao': 'https://gmtor.bb.com.br/administracao/#/catalogo',
        'url_portal': 'https://gmtor.bb.com.br/portal/#/home',

        'timeout_apis': 10000,
        'timeout': 900
    }

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts